import { sites } from '../../estimateBuilder/helpers/globalVariables';

const queryString = require('query-string');

// Timeout in ms
const defaultTimeOut = 500;

/* eslint no-underscore-dangle:0 */
class Utils {
  static parseUrl = (url) => {
    let link = document.createElement('a');

    link.setAttribute('href', url);

    const retValue = {
      port: link.port,
      hostname: link.hostname,
      pathname: link.pathname,
      protocol: link.protocol,
      search: link.search,
    };

    link = null;

    return retValue;
  };

  static getUrlAddress = (url) => {
    const newUrl = Utils.parseUrl(url);
    return `${newUrl.protocol}//${newUrl.hostname}:${newUrl.port}`;
  };

  static parse = search => queryString.parse(search);

  static stringify = parsed => queryString.stringify(parsed);

  static getQueryString = param => queryString.parse(location.search)[`${param}`];

  static DefaultMessage = () => 'OK';
  /* eslint-disable no-undef */

  static sendAnalyticsEvent = (thdAnalyticsEvent, timeOut = defaultTimeOut) =>
    new Promise((resolve) => {
      if (globals.siteId === sites.theHomeDepot) {
        window.digitalData.event.push(thdAnalyticsEvent);
      } else {
        window.ddoEventInit(thdAnalyticsEvent);
      }

      window.setTimeout(resolve(), timeOut);
    });
}
const scrollTillYouReachElement = (elmnt, timeToCheck, numberOfTries) => {
  const bounding = elmnt.getBoundingClientRect();
  let numTries = numberOfTries || 0;
  if (!(bounding.top >= 0 && bounding.top <= 1)) {
    elmnt.scrollIntoView();
    numTries += 1;
    // Check recursively and scroll till the element appears in the view port.
    // Check three times and quit.
    if (numTries <= 3) {
      setTimeout(
        (element, time, numberTries) => {
          scrollTillYouReachElement(element, time, numberTries);
        },
        timeToCheck || 800,
        elmnt,
        timeToCheck,
        numTries,
      );
    }
  }
};

module.exports = { Utils };
